<template>
  <div>
    <div style="width:100%;height:100%">
      <h1 class="chart-top-title">药品生产管理<span class="chart-modal-flag" @click="dialogVisible = true"><i class="el-icon-view" ></i></span></h1>
      <div class="chart-wrapper" ref="chart" style="height:324px;width:100%"></div>
      <p class="remarkes">备注：2012年～2017年全国药品工业企业销售额和进货额对比分析（千万）</p>
    </div>
    <el-dialog :visible.sync="dialogVisible" :append-to-body="true" :fullscreen="true" center :modal="mask">
      <iframe height="100%" width="100%" src="../../../static/js"></iframe>
    </el-dialog>
  </div>
</template>

<script>
import { vueBus } from '../../assets/js/common/vueBus'
export default {
  name: 'barDoubleChart',
  props: {
    echartsData: {
      type: Object,
      default: () => {}
    }
  },
  data() {
    return {
      dialogVisible: false,
      anima:'',
      color: this.$chartColor || ['#08A7DF', '#8ABE32'],
      dataArr: [
        [111744.32, 130357.83, 150214.08, 166132.7, 183925.77, 200162.54],
        [117610.89, 137201.62, 158100.32, 174854.67, 193581.88, 221179.61]
      ],
      xData: ['2012','2013', '2014', '2015', '2016', '2017'],
      axisLabelColor: '#ccd6e0  ',
      axisLineColor: '#809ab1',
      seriesName: ['销售额', '生产额'],
      mask: false
    }
  },
  watch: {
    echartsData: {
      handler: function(val, oldVal) {
        this.initChart()
      },
      deep: true //增加deep 观察对象的子对象变化
    },
     anima: {
      handler: function(val, oldVal) {
        if (val == 'animateStart') {
          this.myChart = this.$echarts.init(this.$refs.chart)
          this.initChart()
        }
      }
    }
  },
  mounted() {
    this.$nextTick(() => {
      let me = this
      vueBus.$on('imgOnload', v => {
        me.anima = v
      })
    })
  },
  methods: {
    handleClose(done) {
            done();
      },
    initChart() {
      let series = []
      this.dataArr.map((item, index) => {
        let colorItem = '';
        if (index === 0) {
          colorItem = new this.$echarts.graphic.LinearGradient(0, 1, 0, 0, [
            {
              offset: 1,
              color: '#13D3F1'
            },
            {
              offset: 0,
              color: this.color[index]
            }
          ])
        }else {
          colorItem = new this.$echarts.graphic.LinearGradient(0, 1, 0, 0, [
            {
              offset: 1,
              color: '#BEE061'
            },
            {
              offset: 0,
              color: this.color[index]
            }
          ])
        }
        series.push(
          {
            name: this.seriesName[index],
            type: 'bar',
            barWidth: '30%',
            data: item,
            itemStyle: {
              color: colorItem
            },
            animationDelay: function(idx) {
              return idx * 100
            },
            animationDuration:function(idx){
              return idx * 200
            }
          }
        )
      })
      let option = {
        tooltip: {
          trigger: 'axis',
          axisPointer: {
            type: 'shadow'
          }
        },
        grid: {
          top: 40,
          bottom: 30,
          left: 20,
          right: 50,
          containLabel: true
        },
        legend: {
          show: false
        },
        xAxis: {
          type: 'category',
          data: this.xData,
          axisLabel: {
            textStyle: {
              color: this.axisLabelColor
            }
          },
          axisTick: {
            show: false
          },
          axisLine: {
            lineStyle: {
              color: this.axisLineColor
            }
          },
          splitLine: {
            show: true,
            lineStyle: {
              width: 1,
              color: this.axisLineColor
            }
          }
        },
        yAxis:
          {
            type: 'value',
            name: '单位：千万',
            nameTextStyle: {
              color: this.axisLabelColor,
              fontSize: 16
            },
            axisLine: {
              show: true,
              lineStyle: {
                color: this.axisLineColor
              }
            },
            axisTick: {
              show: false
            },
            axisLabel: {
              margin: 10,
              textStyle: {
                fontSize: 14
              },
              color: this.axisLabelColor
            },
            splitLine: {
              show: false
            }
          },
        series: series,
        animationEasing: 'elasticOut'
      }
      this.myChart.setOption(option)
      window.onresize = this.myChart.resize
      var currentIndex = -1
      let _this = this
      // setInterval(function() {
      //   var dataLen = option.series[0].data.length

      //   // 取消之前高亮的图形
      //   _this.myChart.dispatchAction({
      //     type: 'downplay',
      //     seriesIndex: 0,
      //     dataIndex: currentIndex
      //   })
      //   currentIndex = (currentIndex + 1) % dataLen
      //   // 高亮当前图形
      //   _this.myChart.dispatchAction({
      //     type: 'highlight',
      //     seriesIndex: 0,
      //     dataIndex: currentIndex
      //   })
      //   // 显示 tooltip
      //   _this.myChart.dispatchAction({
      //     type: 'showTip',
      //     seriesIndex: 0,
      //     dataIndex: currentIndex
      //   })
      // }, 1000)
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>

.chart-modal-flag {
  line-height: 64px;
  font-size: 40px;
  font-weight: 700;
  color: #fff;
  right: 25px;
  position: absolute;
  i {
    color: #fff;
    cursor: pointer;
    font-weight: 900;
  }
}

.chart-top-title {
  height: 76px;
  line-height: 95px;
  font-size: 40px;
  font-weight: 700;
  color: #65ecc3;
  text-align: center;
  letter-spacing: 2px;
  position: relative;
  .chart-select {
    position: absolute;
    width: 175px;
    height: 45px;
    line-height: 45px;
    border: 2px solid #046292;
    left: 28px;
    top: 26px;
    border-radius: 8px;
    font-weight: 400;
    color: #fff;
    font-size: 20px;
    text-align: left;
    padding-left: 20px;
    -webkit-border-radius: 8px;
    -moz-border-radius: 8px;
    -ms-border-radius: 8px;
    -o-border-radius: 8px;
  }
  .select-icon {
    position: absolute;
    font-size: 26px;
    right: 10px;
    top: 3px;
  }
 }
 .remarkes {
  height: 40px;
  line-height: 24px;
  font-size: 20px;
  color: #acb4bc;
  padding-left: 50px;
}
</style>



// WEBPACK FOOTER //
// src/components/echarts/barDoubleChart.vue